import React, { useRef, useEffect } from "react";
import styled from "styled-components";
// import common components
import Typography, { TYPE_ELEMENTS } from "../common-components/Typography";
import CTAButton from "../common-components/CTAButton";
// import assets
import mouseScroll from "../assets/home-mouse-scroll.gif";
// import constants
import CONSTANTS from "../utils/constants/constants";

const LargeBannerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100vw;
  max-width: 100%;
  height: 100dvh;
  overflow: hidden;
  padding-top: 160px;
  box-sizing: border-box;

  @media (max-width: 1280px) {
    padding-top: 140px;
  }

  @media (max-width: 1024px) {
    padding-top: 120px;
  }

  @media (max-width: 900px) {
    padding-top: 100px;
  }

  @media (max-width: 768px) {
    padding-top: 96px;
  }

  @media (max-width: 480px) {
    padding-top: 80px;
  }

  @media (max-height: 480px) {
    padding-top: 70px;
  }

  @media (min-width: 481px) and (max-width: 1400px) and (orientation: portrait) and (hover: none) and (pointer: coarse) {
    // for tablets
    padding-top: 200px;
  }
`;

const LargeVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  max-width: 100%;
  height: 100dvh;
  object-fit: cover;
  pointer-events: none;

  @media (max-width: 1024px) {
    width: 100vw;
    height: 100dvh;
    top: 0;
    left: 0;
    transform: none;
  }

  @media (max-width: 1024px) and (orientation: landscape) {
    width: 100vw;
    height: 100dvh;
    top: 0px;
    left: 0px;
    transform: none;
  }

  @media (max-width: 480px), (max-height: 480px) {
    display: none;
  }
`;

const BannerImg = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${({ opacity }) => opacity};
  display: none;

  @media (max-width: 480px), (max-height: 480px) {
    display: block;
  }
`;

const BannerText = styled.div`
  position: relative;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 90%;
  height: fit-content;
  text-align: center;
  pointer-events: none;
`;

const BannerSubheader = styled.div`
  width: 40%;
  height: fit-content;
  margin-top: 16px;
  pointer-events: none;

  @media (max-width: 1400px) {
    width: 50%;
  }

  @media (max-width: 1280px) {
    width: 60%;
  }

  @media (max-width: 1024px) {
    width: 70%;
  }

  @media (max-width: 480px) {
    width: 80%;
  }
`;

const Scroller = styled.div`
  position: absolute;
  z-index: 999;
  top: calc(100dvh - 120px);
  left: 0;
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-height: 700px) {
    top: calc(100dvh - 64px);
  }
`;

const ScrollerImage = styled.img`
  width: 56px;
  height: 56px;
  object-fit: cover;
  cursor: pointer;
`;

const ButtonWrapper = styled.div`
  position: relative;
  z-index: 999;
  width: fit-content;
  height: fit-content;
  margin-top: 48px;
  pointer-events: all;

  @media (max-height: 480px) {
    margin-top: 24px;
  }
`;

// #FF4F00
export default function VideoBannerLarge({
  video = "",
  img = "",
  alt = "",
  imgLandscape = "",
  headers = [],
  subheader = "",
  onSizeChange = () => {},
  onScrollClick = () => {},
}) {
  const videoRef = useRef(null);
  const outerRef = useRef(null);

  useEffect(() => {
    onSizeChange({
      width: outerRef.current.clientWidth,
      height: outerRef.current.clientHeight,
    });
  }, []);

  const srcSet = (imgUrl) => {
    return [
      `${imgUrl}?w=480&auto=format,compress 480w`,
      `${imgUrl}?w=1024&auto=format,compress 1024w`,
    ].join(", ");
  }

  return (
    <LargeBannerContainer className="large-banner-container" ref={outerRef}>
      <LargeVideo className="large-video" ref={videoRef} autoPlay loop muted>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </LargeVideo>
      <BannerImg
        alt={alt}
        src={window.innerWidth <= 480 ? img : imgLandscape}
        opacity={1}
        sizes="100vw"
        srcSet={window.innerWidth <= 480 ? srcSet(img) : srcSet(imgLandscape)}
      />
      <BannerText>
        {headers.map((header, i) => (
          <Typography
            typeElement={TYPE_ELEMENTS.H_2}
            customColor={!i && headers.length > 1 ? "#FF4F00" : ""}
            customCase="uppercase"
          >
            {header}
          </Typography>
        ))}
        <BannerSubheader>
          <Typography typeElement={TYPE_ELEMENTS.BODY_3} customWeight="300">
            {subheader}
          </Typography>
        </BannerSubheader>
        <ButtonWrapper>
          <CTAButton
            text={CONSTANTS.BUTTONS.CONTACT}
            onClick={() =>
              window.open(CONSTANTS.LINKS.CONTACT_US.LINK, "_self")
            }
            whiteBg={true}
            useGifBg={true}
          />
        </ButtonWrapper>
      </BannerText>
      {/* <Scroller top={outerRef.current?.getBoundingClientRect().bottom}>
        <CTAButton
          text={CONSTANTS.BUTTONS.CONTACT}
          onClick={() => window.open(CONSTANTS.LINKS.CONTACT_US.LINK, "_self")}
          whiteBg={true}
          useGifBg={true}
        />
      </Scroller> */}
    </LargeBannerContainer>
  );
}
